import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fr from './locales/fr.json';

i18n.use(initReactI18next).init({
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: {
    fr: {
      translation: fr,
    },
  },
});

export default i18n;
